import { Modal, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { TextView, Button as BaseButton } from "components";
import { ASSETS, TOAST_TYPE } from "../../../utils/config";
import {
  useConnectStripeAccount,
  usePaymentWithdraw,
} from "../../../services/mutations";
import ToastMessage from "../../../sharedcomponents/Toast";
import { connectStripeAccount, getBalance } from "../../../services/api";
import { isEmpty } from "lodash";
import { colors } from "../../../utils";
import {toast} from 'react-toastify'

const Container = styled.div`
  padding: 20px;
  border-radius: 8px;
  background: #e7f2ff;
  border: 0.5px solid #bbbbbb;
  margin-top: 5px;
`;

const RemainingBalance = styled(TextView)`
  font-size: 14px;
  font-weight: 400;
  font-weight: 700;
`;

const AvailableBalanceTitle = styled(TextView)`
  font-size: 14px;
  color: #565556;
  font-weight: 400;
  opacity: 0.7;
`;

const WithdrawAmountTitle = styled(TextView)`
  font-size: 14px;
  color: #565556;
  font-weight: 400;
`;

const WithdrawFundTitle = styled(TextView)`
  font-size: 20px;
  color: #123051;
  font-weight: 700;
`;

const Edit = styled(TextView)`
  font-size: 12px;
  color: #123051;
  font-weight: 400;
  text-decoration: underline;
  margin-top: 20px;
  margin-left: 10px;
  cursor: pointer;
`;

const AvailableBalance = styled(TextView)`
  background: white;
  font-size: 12px;
  color: #565556;
  font-weight: 400;
  height: 36px;
  border-radius: 5px;
  width: 100%;
  padding: 8px;
  margin-top: 7px;
  margin-bottom: 15px;
  opacity: 0.7;
`;

const TransferToView = styled(TextView)`
  background: #f6f7f9;
  font-size: 12px;
  color: #565556;
  font-weight: 400;
  height: 36px;
  border-radius: 5px;
  padding: 8px;
  margin-top: 7px;
`;

const ToRow = styled.div`
  display:grid;
  grid-template-columns: 1fr auto\;
`;

const RemainingBalanceView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Divider = styled.div`
  width: 100%;
  height: 10px;
  border-bottom: 1px dashed #e1e1e1;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const ConfirmButton = styled(BaseButton)`
  background-color: #123051;
  border-radius: 5px;
  font-size: 12px;
  color: white;
  font-weight: 400;
  border: 0px;
  width: 35%;
  height: 36px;
`;

const CancelButton = styled(BaseButton)`
  background-color: #e7f2ff;
  border-radius: 5px;
  font-size: 12px;
  color: #123051;
  font-weight: 400;
  border: 0px;
  width: 35%;
  height: 36px;
`;

const WithdrawalForm = ({
  isOpen,
  onClose,
  bankDetails,
  cardDetails,
  balance,
  setBalance,
  initialBalance,
  setInitialBalance,
}) => {
  const [withdrawAmount, setWithdrawAmount] = useState("");

  const handleWithdraw = (val) => {
    if (val === "") {
      // If the value is empty, set the balance and withdraw amount to their initial state
      setBalance(initialBalance); // Assuming initial balance is 200, you might adjust this accordingly
      setWithdrawAmount("");
    } else {
      const amount = Number(val);
      setBalance(initialBalance - amount);
      setWithdrawAmount(val);
    }
  };

  const {
    mutate: withdrawMutate,
    isLoading: withdrawIsLoading,
    isError: withdrawIsError,
    data: withdrawData,
  } = usePaymentWithdraw();

  const onClickConfirm = () => {
    if (initialBalance < withdrawAmount || initialBalance==0) {
      return toast.error("You don't have sufficient balance in your account.")
    }
    withdrawMutate(
      { amount: withdrawAmount * 100 },
      {
        onSuccess: () => {
          toast.success("Amount withdrawn successfully!")
          onClose();
        },
        onError: () => {
          toast.error("There was an error while processing.")
          onClose();
        },
      }
    );
  };

  // const {
  //   mutate: connectStripeMutate,
  //   isLoading: connectStripeIsLoading,
  //   isError: connectStripeIsError,
  //   data: connectStripeData,
  // } = useConnectStripeAccount();

  const onClickEdit = async () => {
    let res = await connectStripeAccount();
    if (res?.data) {
      toast.success(res?.data?.message)
      // window.open(res?.data?.url, "_blank");
      window.location.href = res?.data?.url;
    }
    console.log(res, "EDIT RESPONSE");
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ paddingTop: "10vh" }}
      >
        <Stack
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          style={{
            height: "85vh",
            width: "52vw",
            backgroundColor: "white",
            margin: "auto",
            borderRadius: "5px",
            minWidth: 600,
          }}
        >
          <Stack
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            style={{ width: "50%", minWidth: 360 }}
          >
            <Stack
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              style={{ width: "100%" }}
            >
              <img
                src={ASSETS.Withdrawal}
                style={{ height: "52px", width: "52px" }}
                alt="icon"
              />
              <WithdrawFundTitle>Withdraw Funds</WithdrawFundTitle>
              <WithdrawAmountTitle>
                Please review your withdrawal detail.
              </WithdrawAmountTitle>
            </Stack>

            <Stack
              style={{ width: "100%", marginTop: "30px", marginBottom: "30px" }}
            >
              <WithdrawAmountTitle>Transfer to</WithdrawAmountTitle>
              <ToRow>
                <TransferToView>
                  {!isEmpty(bankDetails)
                    ? "********" + bankDetails.last4
                    : !isEmpty(cardDetails)
                    ? "********" + cardDetails?.last4
                    : "N/A"}
                </TransferToView>
                <Edit onClick={onClickEdit}>Edit Details</Edit>
              </ToRow>
            </Stack>
            <Stack
              style={{ width: "100%" }}
              display={"flex"}
              flexDirection={"column"}
            >
              <WithdrawAmountTitle>Your Withdraw Amount</WithdrawAmountTitle>
              <Container>
                <AvailableBalanceTitle>Available balance</AvailableBalanceTitle>
                <AvailableBalance>
                  ${parseFloat(initialBalance.toFixed(2))}
                </AvailableBalance>

                <WithdrawAmountTitle>Withdraw Amount</WithdrawAmountTitle>

                <TextField
                  // autoFocus
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                    // inputProps: { maxLength: 30 },
                  }}
                  placeholder=""
                  // defaultValue={"Add title here |"}
                  // value={"$"`${withdrawAmount}`}
                  value={withdrawAmount}
                  name="title"
                  id="title-with-emoji"
                  onChange={(e) => {
                    const value = e.target.value;
                    const keyCode = e.keyCode || e.which;
                    if (keyCode === 8 || !isNaN(value)) {
                      handleWithdraw(value);
                    }
                  }}
                  fullWidth
                  style={{
                    paddingLeft: "8px",
                    fontWeight: "900",
                    fontFamily: "DM Sans",
                    backgroundColor: "white",
                    height: "36px",
                    borderRadius: "5px",
                    paddingTop: "2px",
                    marginTop: "4px",
                  }}
                />

                <Divider></Divider>
                <RemainingBalanceView>
                  <WithdrawAmountTitle>Remaining Balance:</WithdrawAmountTitle>
                  <RemainingBalance
                    style={{
                      color: balance < 0 ? colors.red : colors.darkGrey,
                    }}
                  >
                    {balance < 0 && "-"}$
                    {Math.abs(parseFloat(balance.toFixed(2)))}
                  </RemainingBalance>
                </RemainingBalanceView>

                <ToRow>
                  <ConfirmButton disabled={initialBalance==0} onClick={onClickConfirm}>
                    Confirm
                  </ConfirmButton>
                  <CancelButton onClick={onClose}>Cancel</CancelButton>
                </ToRow>
              </Container>
            </Stack>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
};

export default WithdrawalForm;
